import { PopoverTrigger, Popover } from "@radix-ui/react-popover";
import { PopoverContent } from "./content/content";
const PopoverWithSubComponents = Object.assign(Popover, {
    Trigger: PopoverTrigger,
    Content: PopoverContent,
});
export { PopoverWithSubComponents as Popover, Popover as PopoverRoot, PopoverTrigger, PopoverContent };
